export const ZOOM_LEVEL = {
    HIGH: "high",
    MEDIUM: "medium",
    LOW: "low"
};
